import React from 'react';

import { gql } from '@apollo/client';
import { RichText } from '@/components/rich-text/rich-text';
import { getTagBorderColor } from '@/helpers/tailwindColors';

export interface RichTextBlockProps {
  blocktype: 'BlockRichText';
  id: string;
  name: string;
  title?: string;
  tagsCollection?: {
    items: { sys: { id: string }; tagName: string; colour: string }[];
  };
  richText: any;
}

const RichTextBlock = ({
  richText,
  title,
  tagsCollection,
}: RichTextBlockProps) => {
  const tags = tagsCollection?.items?.filter(Boolean);
  return (
    <>
      {title && (
        <h2 className="w-full break-words font-title text-headingm text-text-default">
          {title}
        </h2>
      )}
      {tags && tags.length > 0 && (
        <div className="mb-4 flex flex-wrap gap-2 mt-4">
          {tags.map((tag) => {
            const borderColor = getTagBorderColor(tag.colour);
            return (
              <span
                key={tag.sys.id}
                className={`border-2 ${borderColor} py-2 px-3 rounded-md text-headingxxs text-neutral-grey-700 whitespace-nowrap`}
              >
                {tag.tagName}
              </span>
            );
          })}
        </div>
      )}
      {richText ? <RichText richText={richText} /> : null}
    </>
  );
};

export default RichTextBlock;

// export const query = gql`
//   fragment RichTextBlock on ContentfulBlockRichText {
//     blocktype: __typename
//     sys {
//       id
//     }
//     internalName
//     richText {
//       raw
//       references {
//         ...Asset
//         ...Entry
//       }
//     }
//   }
// `;
